import { Link } from '@inertiajs/react';
import { MessageSquare, Sparkles } from 'lucide-react';

export default function Index() {
  return (
    <div className="container mx-auto p-8">
      <h1 className="text-2xl font-semibold mb-2">Dev Tools</h1>
      <p className="text-muted-foreground mb-8">Admin pages for managing Studio Chat</p>

      <div className="grid gap-4 md:grid-cols-2 max-w-2xl">
        <Link
          href="/dev/chats"
          className="block p-6 rounded-lg border hover:border-primary hover:bg-muted/50 transition-colors"
        >
          <MessageSquare className="h-8 w-8 mb-3 text-primary" />
          <h2 className="font-semibold mb-1">All Chats</h2>
          <p className="text-sm text-muted-foreground">
            View and manage chat sessions from all users
          </p>
        </Link>

        <Link
          href="/dev/chat_recommendations"
          className="block p-6 rounded-lg border hover:border-primary hover:bg-muted/50 transition-colors"
        >
          <Sparkles className="h-8 w-8 mb-3 text-primary" />
          <h2 className="font-semibold mb-1">Chat Recommendations</h2>
          <p className="text-sm text-muted-foreground">
            Configure workflow recommendations for the chat assistant
          </p>
        </Link>
      </div>
    </div>
  );
}
